<template>
  <div>
    <el-select :value="value" value-key="id" :size="size" @input="change($event)" :clearable="true" :placeholder="$t('table.wechat_pay')">
      <el-option label="----------" :value="emptyValue" />
      <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item" />
    </el-select>
    <el-button v-if="config && config.update" @click="handleUpdate" >{{ $t('table.update') }}</el-button>
  </div>
</template>

<script>

import { fetchPartnerList } from '../api/wechat'
export default {
  data () {
    return {
      emptyValue: { id: 0 },
      options: []
    }
  },
  created () {
    fetchPartnerList({limit: 0}).then((res) => {
      this.options = res.data.map((item) => { item.id = parseInt(item.id); return item })
    })
  },
  props: ['value', 'config', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.$emit('input', val)
    },
    handleUpdate () {
      fetchPartnerList({limit: 0}).then((res) => {
        this.options = res.data
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/WechatPaySelect.vue